import apiClient from "@/lib/axios";

export interface Language {
    code: string,
    iso_code: string,
    country_code: string,
    name: string,
    native_name: string,
    flag: string,
    quality_score: number
}

export const getLanguages = async (): Promise<Language[]> => {
    const response = await apiClient.get("/api/v1/catalog/languages");
    return response.data;
};
